import { render, staticRenderFns } from "./LocalLogin.vue?vue&type=template&id=8c6e0c7c&"
import script from "./LocalLogin.vue?vue&type=script&lang=js&"
export * from "./LocalLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports